module.exports = __webpack_public_path__ + "img/uk_failure_8.791864f5.png";